/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var LOG = require('logger').getLogger('fabric.touchSpin'), $ = window.jQuery = require('base');
module.exports = {
		touch:function(){
			var $this = this;
			require.ensure('bootstrap-touchspin', function () {
				require('bootstrap-touchspin');
				$('input[data-prop-path$="count"]').each(function(){
					var $this = $(this), option = new Function('return ' + $this.data('option'))();
					$this.TouchSpin($.extend({
						initval : 1, // ĺĺ§ĺź
						min : 1,
						max : 99999,
						step : 1,
						verticalbuttons : true,
						verticalupclass : 'icon-starry-normal-plus4 j-a-btn-num-up',
						verticaldownclass : 'icon-starry-normal-minus5 j-a-btn-num-down'
					}, option));
				})
				$this.touchdef.resolve();
			});
		
		}
,touchdef:$.Deferred()
}


// WEBPACK FOOTER //
// ./src/main/javascript/product/fabric/com.jufeng.fabric.touchSpin.js